import { useTranslation } from "react-i18next";
import { Button, makeStyles, SvgIcon, Typography } from "@material-ui/core";

import type { RuleType } from "pages/Rules/common/types";

type Props = {
  action: RuleType;
  active: boolean;
  icon: typeof SvgIcon;
  onClick: (newAction: RuleType) => void;
};

export default function ActionButton(props: Props) {
  const { t } = useTranslation("rules");
  const classes = useStyles();
  const { action, onClick, active, icon: Icon } = props;

  return (
    <Button
      fullWidth
      disableElevation
      size="large"
      className={classes.actionButton}
      variant={active ? "contained" : "outlined"}
      color={active ? "primary" : "default"}
      onClick={() => onClick(action)}
    >
      <Icon fontSize="large" />
      <Typography className={classes.actionBtnTitle} gutterBottom>
        {t(`actions.${action}.title`)}
      </Typography>
    </Button>
  );
}

const useStyles = makeStyles({
  actionButton: { display: "block", minHeight: "143px", paddingTop: "10px" },
  actionBtnTitle: { fontWeight: 500, padding: "0 2px" },
});
